export default "__VITE_ASSET__a72b136d__"